import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
var BillingPlansComponent = /** @class */ (function () {
    function BillingPlansComponent(dashboardService, router) {
        this.dashboardService = dashboardService;
        this.router = router;
        this.allBillPlans = [];
        this.allPlans = [];
        this.planType = [];
        this.planDetails = {};
        this.existplan = false;
        this.createPlan = false;
        this.cplan = {};
        this.loading = false;
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.subscriptions = [];
    }
    BillingPlansComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "inline-table";
        }
        else {
            return "none";
        }
    };
    BillingPlansComponent.prototype.ngOnInit = function () {
        var _this = this;
        var s1 = this.dashboardService.billingPlans().subscribe(function (data) {
            _this.allBillPlans = data;
            _this.allPlans = data.allPlans;
            _this.planType = data.planType;
            console.log(_this.allBillPlans);
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s1);
    };
    BillingPlansComponent.prototype.planSelect = function () {
        var _this = this;
        if (this.planValue != "") {
            this.allPlans.forEach(function (element) {
                if (element.objId == _this.planValue) {
                    _this.planDetails = element;
                    _this.existplan = true;
                    _this.createPlan = false;
                }
            });
        }
        this.cplan = this.planDetails;
        console.log(this.planDetails);
    };
    BillingPlansComponent.prototype.newPlan = function () {
        this.createPlan = true;
        this.existplan = false;
        this.cplan = {};
    };
    BillingPlansComponent.prototype.cPlanNew = function () {
        var _this = this;
        this.loading = true;
        if (this.cplan.isDefault == "0") {
            this.cplan.isDefault = false;
        }
        else {
            this.cplan.isDefault = true;
        }
        if (this.cplan.display == true) {
            this.cplan.display = 1;
        }
        else {
            this.cplan.display = 0;
        }
        console.log(this.cplan);
        var s2 = this.dashboardService.addNewPlan(this.cplan).subscribe(function (data) {
            console.log(data);
            _this.planValue = "";
            _this.existplan = false;
            _this.createPlan = false;
            _this.dashboardService.billingPlans().subscribe(function (data) {
                _this.allBillPlans = data;
                _this.allPlans = data.allPlans;
                _this.planType = data.planType;
                console.log(_this.allBillPlans);
                _this.loading = false;
            }, function (error) {
                if (error.Uvsity_Errors) {
                    _this.msgTitle = "Error";
                    _this.msgContent = error.Uvsity_Errors;
                    _this.popUp = true;
                }
            });
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s2);
    };
    BillingPlansComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return BillingPlansComponent;
}());
export { BillingPlansComponent };
//# sourceMappingURL=billingPlans.component.js.map